import TablerIconHexagonLetterW from '~icons/tabler/hexagon-letter-w';

export type WorkspaceIconProps = React.ComponentProps<
  typeof TablerIconHexagonLetterW
>;
export const WorkspaceIcon = TablerIconHexagonLetterW;
